import styled from "styled-components"

export const StyledAppealsList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`
